import React from 'react';
import { Box } from '@mui/material';

export default function Masters() {
    return (
        <Box>

        </Box>
    )
}